import {fromJS, Set, Map} from 'immutable';
import QuestionTypeStore from 'components/QuestionTypes/QuestionType.store';
import snippetSelectionQuestionActions from './SnippetSelectionQuestion.actions';
import {activeQuestionActions} from 'client/InteractionEngineV2/shared/ActiveQuestion/ActiveQuestionActions';
import questionTypeActions from 'components/QuestionTypes/questionType.actions';

export default class SnippetSelectionQuestionStore extends QuestionTypeStore {
  constructor(name, questionId, question) {
    super(name);
    this.setInitialData(
      fromJS({
        questionId: questionId,
        selectedOptions: Set(),
        shouldShowExplanation: false
      })
    );
    this.writeData('__question', question);
    this.writeData('selectedOptions', new Set());
    this.handleTargeted(questionTypeActions.CLEAR_GUESS, this._clearGuess);
    this.handleTargeted(questionTypeActions.LOAD_GUESS, this._loadGuess);
    this.handleTargeted(activeQuestionActions.ACTIVE_QUESTION_LOAD_GUESS, this._loadGuess);
    this.handleTargeted(activeQuestionActions.ACTIVE_QUESTION_CLEAR_GUESS, this._clearGuess);
    this.handleTargeted(snippetSelectionQuestionActions.TOGGLE_OPTION, this._toggleOption);
  }

  _toggleOption(optionId) {
    if (this.isOptionSelected(optionId)) {
      this.writeData('selectedOptions', this.getSelectedOptions().delete(optionId));
    } else {
      this.writeData('selectedOptions', this.getSelectedOptions().add(optionId));
    }
  }

  getSelectedOptions() {
    return this.readData('selectedOptions');
  }

  isOptionSelected(optionId) {
    return this.getSelectedOptions().includes(optionId);
  }

  isOptionCorrect(optionId) {
    return this.getCorrectAnswers().includes(optionId);
  }

  getCorrectAnswers() {
    return this.validResponse.keySeq().toSet();
  }

  buildGuessContent() {
    const selectedOptions = this.readData('selectedOptions');
    return selectedOptions.reduce((result, option) => {
      result[option] = true;
      return result;
    }, {});
  }

  _loadGuess(guess) {
    super._loadGuess(guess);

    const selectedOptions = guess.get('content', new Map()).map((val, optionId) => optionId);
    this.writeData('selectedOptions', selectedOptions);
  }

  _clearGuess() {
    super._clearGuess();

    this.writeData('selectedOptions', this.initialData.get('selectedOptions'));
  }
}
